import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import Details from './Details'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'
import TemplateLoader from './_load/TemplateLoader'

const TemplatesModal = props => {
  return (
    <ControlledModal width="38rem" {...props}>
      <TemplateLoader>
        <ModalHeader />

        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={2} />

        <Details />
      </TemplateLoader>
    </ControlledModal>
  )
}

export default TemplatesModal
